/* proposalHeadings.js
 *
 * ONE reader for proposal and contract section headings, shared by the admin
 * editor and the client portal.
 *
 * WHY THIS FILE EXISTS. The backend has always sent a `sectionHeadings` map on
 * every proposal, and every section in the admin editor has always declared a
 * `headingKey`. Neither was ever read. Both screens printed their own hardcoded
 * labels instead, which is how one section ended up with three different names.
 *
 * The heading now comes from the record. The hardcoded label survives only as
 * the last resort for a record that carries no headings at all.
 */
export function headingFor(content, headingKey, fallbackLabel) {
  if (!headingKey) return fallbackLabel;
  const map = content && content.sectionHeadings;
  const value = map && map[headingKey];
  if (typeof value === 'string' && value.trim()) return value.trim();
  return fallbackLabel;
}
